module.exports = __webpack_public_path__ + "img/Rectangle10.ff0b5685.svg";